import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("b", null, "Wilt u bovenstaande producten definitief bestellen?", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

import { computed, ref } from 'vue'
import { generalStore } from '@/stores/general'
import { WarningTwoTone } from '@ant-design/icons-vue'
import { summaryStore } from '@/stores/v2/summary'
import WoononResetCompletionButton from '@/components/v2/summary/WoononResetCompletionButton.vue'
import axios from 'axios'
import { notification } from 'ant-design-vue'
import { headerStore } from '@/stores/header'
import { modularStore } from '@/stores/v2/modular'
import { carcassStore } from '@/stores/v2/carcass'
import { completion1Store } from '@/stores/v2/completion1'
import { completion2Store } from '@/stores/v2/completion2'
import { completion3Store } from '@/stores/v2/completion3'


export default /*#__PURE__*/_defineComponent({
  __name: 'WoononPhaseCreateOrder',
  props: {
    phase: null,
    phaseLabel: null
  },
  emits: ['orderCreated'],
  setup(__props: any, { emit }) {

const props = __props as {
  phase:'modular'|'carcass'|'completion'|'extra',
  phaseLabel:string
};




const loading = ref(false)

const agreeToTerms = ref({
  excludedFromWarranty: false,
  responsibility: false,
  activities: false,
  general: false
})

const showExcludedFromWarrantyTerms = computed(() => {
  if (props.phase === 'completion') {
    return !!(
      summaryStore().summary?.completion1.has_excluded_from_warranty_products ||
      summaryStore().summary?.completion2.has_excluded_from_warranty_products ||
      summaryStore().summary?.completion3.has_excluded_from_warranty_products
    )
  }

  return false
})

const agreedToAllTerms = computed(() => {
  if (showExcludedFromWarrantyTerms.value) {
    return agreeToTerms.value.excludedFromWarranty &&
      agreeToTerms.value.responsibility &&
      agreeToTerms.value.activities &&
      agreeToTerms.value.general
  }

  return agreeToTerms.value.general
})

function createOrder () : void {
  loading.value = true
  axios.post(process.env.VUE_APP_API_URL_V2 + '/order/' + props.phase).then(() => {
    headerStore().setOrdersReceived(props.phase)

    if (props.phase === 'modular') {
      modularStore().phaseState = 'closed'
    } else if (props.phase === 'carcass') {
      carcassStore().phaseState = 'closed'
    } else if (props.phase === 'completion') {
      completion1Store().phaseState = 'closed'
      completion2Store().phaseState = 'closed'
      completion3Store().phaseState = 'closed'
    }

    emit('orderCreated')

    notification.success({
      message: 'Bestelling succesvol.',
      description: 'Uw bestelling is succesvol geplaatst.',
      duration: 5
    })
  }).catch(() => {
    notification.error({
      message: 'Bestelling NIET succesvol.',
      description: 'Er is iets mis gegaan. Probeer het later nog een keer.',
      duration: 0
    })
  }).finally(() => {
    loading.value = false
  })
}

return (_ctx: any,_cache: any) => {
  const _component_a_divider = _resolveComponent("a-divider")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_popconfirm = _resolveComponent("a-popconfirm")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_a_divider),
    _createVNode(_component_a_row, {
      gutter: [16,16],
      class: "no-mb"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_col, { span: 24 }, {
          default: _withCtx(() => [
            _createElementVNode("p", {
              class: "no-mb",
              style: _normalizeStyle(_unref(generalStore)().desktop ? { margin: '0 0 0 24px' } : { margin: '0' })
            }, [
              _createTextVNode(" De extra opties zijn een aanvulling op de tussen de ondernemer en verkrijger gesloten (koop-) aannemingsovereenkomst."),
              _hoisted_1,
              _createTextVNode(" De Woningborg Garantie- en waarborgregeling is tevens van toepassing op de gekozen extra opties. ")
            ], 4)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_a_divider),
    _createVNode(_component_a_row, { gutter: [16,16] }, {
      default: _withCtx(() => [
        (_unref(showExcludedFromWarrantyTerms))
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createVNode(_component_a_col, { span: 24 }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_checkbox, {
                    checked: agreeToTerms.value.excludedFromWarranty,
                    onChange: _cache[0] || (_cache[0] = ($event: any) => (agreeToTerms.value.excludedFromWarranty = !agreeToTerms.value.excludedFromWarranty))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Ik/wij ga(an) ermee akkoord dat de keuze van gemarkeerde ("),
                      _createVNode(_unref(WarningTwoTone), { "two-tone-color": "#f38929" }),
                      _createTextVNode(") opties tot gevolg heeft dat het betreffende onderdeel is uitgesloten van de toepasselijke Woningborg Garantie- en waarborgregeling en dat de ondernemer niet aansprakelijk gesteld kan worden voor gebreken en/of schaden en/of gevolgschaden ten gevolge van het niet leveren en/of aanbrengen van betreffende materialen en constructies. Voor de gemarkeerde opties waarbij dit tekstueel is aangegeven, geldt dat bij oplevering niet voldaan wordt aan de wettelijke voorschriften (met name het Bouwbesluit).")
                    ]),
                    _: 1
                  }, 8, ["checked"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_col, { span: 24 }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_checkbox, {
                    checked: agreeToTerms.value.responsibility,
                    onChange: _cache[1] || (_cache[1] = ($event: any) => (agreeToTerms.value.responsibility = !agreeToTerms.value.responsibility))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Ik/wij aanvaard(en) de verantwoordelijkheid om de woning c.q. het privé-gedeelte na oplevering op de niet uit te voeren onderdelen aan de wettelijke voorschriften te laten voldoen. Deze verantwoordelijkheid verschuift van de ondernemer naar mij/ons als koper.")
                    ]),
                    _: 1
                  }, 8, ["checked"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_col, { span: 24 }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_checkbox, {
                    checked: agreeToTerms.value.activities,
                    onChange: _cache[2] || (_cache[2] = ($event: any) => (agreeToTerms.value.activities = !agreeToTerms.value.activities))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Ik/wij verklaren, dat de ondernemer opdracht krijgt om de woning zonder de vermelde werkzaamheden en/of materialen uit te voeren en/of te leveren.")
                    ]),
                    _: 1
                  }, 8, ["checked"])
                ]),
                _: 1
              })
            ], 64))
          : _createCommentVNode("", true),
        _createVNode(_component_a_col, { span: 24 }, {
          default: _withCtx(() => [
            _createVNode(_component_a_checkbox, {
              checked: agreeToTerms.value.general,
              onChange: _cache[3] || (_cache[3] = ($event: any) => (agreeToTerms.value.general = !agreeToTerms.value.general))
            }, {
              default: _withCtx(() => [
                _createTextVNode("Ik/wij ga(an) ermee akkoord dat met het versturen van de opties opdracht gegeven wordt tot de uitvoering van meer- (en minder)werk en dat na de sluitingsdatum deze opties niet meer gewijzigd kunnen worden.")
              ]),
              _: 1
            }, 8, ["checked"])
          ]),
          _: 1
        }),
        (__props.phase === 'completion')
          ? (_openBlock(), _createBlock(_component_a_col, {
              key: 1,
              span: 12
            }, {
              default: _withCtx(() => [
                _createVNode(WoononResetCompletionButton)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_a_col, {
          span: __props.phase === 'completion' ? 12 : 24
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_popconfirm, {
              placement: "topRight",
              "ok-text": "Ja, bestellen",
              onConfirm: createOrder
            }, {
              title: _withCtx(() => [
                _hoisted_2,
                _hoisted_3,
                _createTextVNode(" Controleer uw gemaakte keuzes nogmaals, deze kunnen na het plaatsen van de bestelling niet meer worden gewijzigd. ")
              ]),
              default: _withCtx(() => [
                _createVNode(_component_a_button, {
                  type: "primary",
                  loading: loading.value,
                  disabled: !_unref(agreedToAllTerms) || loading.value,
                  style: _normalizeStyle(_unref(generalStore)().desktop ? { float: 'right' } : { width: '100%' })
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(__props.phaseLabel) + " - Bestelling plaatsen", 1)
                  ]),
                  _: 1
                }, 8, ["loading", "disabled", "style"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["span"])
      ]),
      _: 1
    })
  ], 64))
}
}

})